import { useState } from "react";
import { DeleteIcon, SaveIcon } from "../../../assets/icons";
import { useConfirmPopup } from "../../../components/popup/confirmPopup/confirmPopup";
import classNames from "classnames";
import AdminAPI from "../../../api/AdminAPI";

import styles from "./cafeKPIPage.module.css";
import { useParams } from "react-router";

import { Text } from "../../../components/text/text";

export const FileItem = ({ data, onDeleteCallback }) => {
    const [isDeleting, setIsDeleting] = useState(false);
    const [isPreviewLoading, setIsPreviewLoading] = useState(false);
    const [deletionPreview, setDeletionPreview] = useState(null);
    const [previewError, setPreviewError] = useState(null);
    const [loading, setLoading] = useState(false);

    const { cafeId } = useParams();
    const onDelete = () => {
        if (!cafeId || !data.id) return;
        setIsDeleting(true);
        AdminAPI
            .deleteReport(cafeId, data.id)
            .then(() => onDeleteCallback(data.id))
            .catch(console.error)
            .finally(() => setIsDeleting(false));
    }

    const onSave = () => {
        if (!cafeId) return;
        setLoading(true);
        setProgress(0);
        AdminAPI
            .downloadReport(cafeId, data.id)
            .catch(console.error)
            .finally(() => setTimeout(() => {
                setLoading(false);
                setProgress(0);
            }, 300));
    }

    const [Popup, open] = useConfirmPopup(
        "Подтвердите действие",
        deletionPreview
            ? `Будет удалено чеков: ${deletionPreview.checksCount}. Общая выручка уменьшится на ${Number(deletionPreview.revenueDecrease || 0).toLocaleString("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₽.`
            : "",
        onDelete,
    );

    const openDeletionPreview = async () => {
        if (!cafeId || !data.id || isDeleting || isPreviewLoading) return;
        setIsPreviewLoading(true);
        setPreviewError(null);
        try {
            const preview = await AdminAPI.getReportDeletionPreview(cafeId, data.id);
            setDeletionPreview(preview);
            open();
        } catch (error) {
            console.error(error);
            setPreviewError("Не удалось получить данные для удаления отчета");
        } finally {
            setIsPreviewLoading(false);
        }
    };

    const [progress, setProgress] = useState(0);

    return (
        <>
            <div className={styles.file_container}>
                <div className={styles.file_header}>
                    <DeleteIcon onClick={openDeletionPreview} />
                    <div className={classNames(styles.download_button, { [styles.downloading]: loading })} onClick={() => (!loading) && onSave()}>
                        <svg className={styles.download_progress} width={24} height={24} viewBox={`0 0 24 24`} fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle
                                cx={12} cy={12} r={10}
                                style={{ stroke: "var(--app-hint-color)" }}
                                fill="none"
                                strokeWidth={2}
                            />
                            <circle
                                cx={12} cy={12} r={10}
                                style={{ stroke: "var(--app-info-color)", transition: "stroke-dashoffset .3s ease-out", transform: "rotateX(180deg)", transformOrigin: "50% 50%" }}
                                fill="none"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeDasharray={2 * Math.PI * 10}
                                strokeDashoffset={2 * Math.PI * 10 * (1 - progress)}
                            />
                        </svg>
                        <SaveIcon className={styles.download_icon} />
                    </div>
                </div>
                <Text as="div" variant="captionStrong" className={styles.file_name} >
                    {data.originalFilename}
                </Text>
                {previewError && (
                    <Text as="div" variant="caption" align="center">
                        {previewError}
                    </Text>
                )}
            </div>

            {Popup}
        </>
    );
}
